import { QUICK_TASK, QUOTE_AFTER_INSPECTION, QUOTE_WITHOUT_INSPECTION } from '../constants/taskTypes'

export const renderTaskColor = (type) => {
    switch (type) {
        case QUICK_TASK:
            return { lineColor: "#FF6347", backgroundColor: "rgba(249, 122, 99, 0.03)" }
        case QUOTE_AFTER_INSPECTION:
            return { lineColor: "blueviolet", backgroundColor: "rgba(155, 75, 229, 0.08)" }
        case QUOTE_WITHOUT_INSPECTION:
            return { lineColor: "#03A9F4", backgroundColor: "rgba(122, 204, 242, 0.06)" }
        default:
            return { lineColor: "black", backgroundColor: "white" }
    }
}
// Formats a number as "Rs. 1,234.00"
export const formatMoney = (amount) => {
    const value = Number(amount)
    if (!isFinite(value)) {
        return 'Rs. 0.00'
    }
    return `Rs. ${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}
